import BasicCondInput from "components/BasicInputs/BasicCondInput";
import { useEffect, useState } from "react";

export interface CondInputProps {
  val: {
    val: string;
    cond: BasicCondInputProps["cond"];
  };
  data: TableCol["data"];
  options?: any;
  row: any;
  colKey: string;
  onChange: (item: any, options?: any) => void;
  onWheel: (e: any) => void;
  withBorder?: boolean;
  style?: React.CSSProperties;
}
export default function CondInput(props: CondInputProps) {
  const { val, options, row } = props;
  const [count, setCount] = useState(0);
  const conditions = props?.options?.conditions || row[props?.options?.conditionsKey] || [];
  const deps: string[] = props?.options?.deps || [];
  const literalDeps: any[] = props?.options?.literalDeps || [];
  let onChange = props.onChange;
  if (options && options.onChange) onChange = options.onChange;

  useEffect(() => {
    setCount((x) => x + 1);
  }, [...deps.map((x) => row[x]), ...literalDeps]);

  function handleChange(val: CondInputProps["val"]) {
    onChange(val, { row, options });
  }
  function handleOnWheel(e:any){
    e.target.blur()
    e.preventDefault()
  }

  return (
    <BasicCondInput
      key={count}
      {...{ conditions, ...val }}
      onchange={handleChange}
      styles={{ ...props.style, ...props?.options?.style }}
      onWheel={handleOnWheel}
      type={"quantity"}
    />
  );
}
